import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'


const ProvincesDataSetup = lazy(() => import ('./ProvincesDataSetup/ProvincesDataSetup'))
const DistrictsDataSetup = lazy(() => import ('./DistrictsDataSetup/DistrictsDataSetup'))
const DivisionalSecretariatsDataSetup = lazy(() => import ('./DivisionalSecretariatsDataSetup/DivisionalSecretariatsDataSetup'))
const GNDivisionsDataSetup = lazy(() => import ('./GNDivisionsDataSetup/GNDivisionsDataSetup'))
const SchoolsDataSetup = lazy(() => import ('./SchoolsDataSetup/SchoolsDataSetup'))
const PoliceStationsDataSetup = lazy(() => import ('./PoliceStationsDataSetup/PoliceStationsDataSetup'))
const CaseCloseReasonsDataSetup = lazy(() => import ('./CaseCloseReasonsDataSetup/CaseCloseReasonsDataSetup'))
const ComplaintModeDataSetup = lazy(() => import ('./ComplaintModeDataSetup/ComplaintModeDataSetup'))
const CaseReferredTo = lazy(() => import ('./CaseReferredTo/CaseReferredTo'))
const TypeofComplaint = lazy(() => import ('./TypeofComplaint/TypeofComplaint'))
const PoliceDivisionsDataSetup = lazy(() => import ('./PoliceDivisionsDataSetup/PoliceDivisionsDataSetup'))
const IncidentLocationTypesDataSetup = lazy(() => import ('./IncidentLocationTypes/IncidentLocationTypes'))
const IncidentLocationDataSetup = lazy(() => import ('./IncidentLocation/IncidentLocation'))


const DataSetupRoutes = [
    {
        path: '/ProvincesDataSetup',
        component: ProvincesDataSetup,
        auth: authRoleAccess.data_setup,
    },
    {
        path: '/DistrictsDataSetup',
        component: DistrictsDataSetup,
        auth: authRoleAccess.data_setup,
    },
    {
        path: '/DivisionalSecretariatsDataSetup',
        component: DivisionalSecretariatsDataSetup,
        auth: authRoleAccess.data_setup,
    },
    {
        path: '/GNDivisionsDataSetup',
        component: GNDivisionsDataSetup,
        auth: authRoleAccess.data_setup,
    },
    {
        path: '/SchoolsDataSetup',
        component: SchoolsDataSetup,
        auth: authRoleAccess.data_setup,
    },
    {
        path: '/PoliceDivisionsDataSetup',
        component:PoliceDivisionsDataSetup,
        auth: authRoleAccess.data_setup,
    },
    {
        path: '/PoliceStationsDataSetup',
        component: PoliceStationsDataSetup,
        auth: authRoleAccess.data_setup,
    },
    {
        path: '/CaseCloseReasonsDataSetup',
        component: CaseCloseReasonsDataSetup,
        auth: authRoleAccess.data_setup,
    },
    {
        path: '/ComplaintModeDataSetup',
        component: ComplaintModeDataSetup,
        auth: authRoleAccess.data_setup,
    },
    {
        path: '/CaseReferredTo',
        component: CaseReferredTo,
        auth: authRoleAccess.data_setup,
    },
    {
        path: '/TypeofComplaint',
        component: TypeofComplaint,
        auth: authRoleAccess.data_setup,
    },
    {
        path: '/IncidentLocationTypes',
        component: IncidentLocationTypesDataSetup,
        auth: authRoleAccess.data_setup,
    },
    {
        path: '/IncidentLocation',
        component: IncidentLocationDataSetup,
        auth: authRoleAccess.data_setup,
    },
   
]

export default DataSetupRoutes